import axios from 'axios';

const mail = axios.create({
    baseURL: 'https://services.dommusbeta.com.br/'
});

export default mail;